// frontend/src/pages/Login.tsx

import React from 'react';
import { Form, Input, Button, message } from 'antd';
import { useNavigate } from 'react-router-dom';
import { auth } from '../firebase/config';
import { signInWithEmailAndPassword } from 'firebase/auth';

interface ApplyValues {
  email: string;
  name: string;
  reason: string;
}

const submitApplication = async (values: ApplyValues) => {
  const response = await fetch('/exchangeInfo', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(values),
  });
  const data = await response.json();
  if (response.ok && data.success) {
    message.success('申請成功，請等待審核');
  } else {
    message.error('申請失敗：' + (data.error || '未知錯誤'));
  }
};

const LoginPage: React.FC = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [applyForm] = Form.useForm();

  const onLoginFinish = async ({ email, password }: { email: string; password: string }) => {
    try {
      await signInWithEmailAndPassword(auth, email.trim(), password);
      message.success('登入成功');
      navigate('/');  // 登入成功後跳轉到 Home 界面
    } catch (err: any) {
      console.error('登入錯誤', err);
      const code = err.code;
      message.error(
        code === 'auth/invalid-email' ? '電子郵件格式不正確' :
        code === 'auth/user-not-found'  ? '使用者不存在' :
        code === 'auth/wrong-password' ? '密碼錯誤' :
        code === 'auth/invalid-api-key'? 'API 金鑰錯誤，請檢查ENV' :
        '登入失敗，請稍後再試'
      );
    }
  };

  const onApplyFinish = async (values: ApplyValues) => {
    await submitApplication(values);
    applyForm.resetFields();
  };

  return (
    <div style={{ maxWidth: 400, margin: '0 auto', padding: 20 }}>
      <h2>使用者登入</h2>
      <Form form={form} onFinish={onLoginFinish} layout="vertical">
        <Form.Item
          label="Email"
          name="email"
          rules={[{ required: true, message: '請輸入 Email' }]}
        >
          <Input
            id="login-email"
            autoComplete="username"
            placeholder="user@example.com"
          />
        </Form.Item>
        <Form.Item
          label="Password"
          name="password"
          rules={[{ required: true, message: '請輸入密碼' }]}
        >
          <Input.Password
            id="login-password"
            autoComplete="current-password"
            placeholder="請輸入密碼"
          />
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit" block>
            登入
          </Button>
        </Form.Item>
      </Form>

      <h2 style={{ marginTop: 40 }}>申請存取權限</h2>
      <Form form={applyForm} onFinish={onApplyFinish} layout="vertical">
        <Form.Item
          label="Email"
          name="email"
          rules={[{ required: true, message: '請輸入 Email' }]}
        >
          <Input
            id="apply-email"
            autoComplete="email"
            placeholder="申請用 Email"
          />
        </Form.Item>
        <Form.Item
          label="Name"
          name="name"
          rules={[{ required: true, message: '請輸入姓名' }]}
        >
          <Input
            id="apply-name"
            autoComplete="name"
            placeholder="您的姓名"
          />
        </Form.Item>
        <Form.Item
          label="Reason"
          name="reason"
          rules={[{ required: true, message: '請輸入申請原因' }]}
        >
          <Input.TextArea
            id="apply-reason"
            autoComplete="off"
            placeholder="請輸入申請原因"
            rows={4}
          />
        </Form.Item>
        <Form.Item>
          <Button htmlType="submit" block>
            送出申請
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default LoginPage;
